import { FormatMessageFunction } from '@common/types/Translation';
import { EMAIL_REGEX } from '@constants/common';
import * as Yup from 'yup';

export const createForgotPasswordSchema = (formatMessage: FormatMessageFunction) =>
    Yup.object({
        email: Yup.string()
            .required(
                formatMessage(
                    {
                        id: 'schema.errors.required',
                        defaultMessage: '{field} is required',
                        description: 'Error message displayed when user leaves a mandatory field empty. Used in forms',
                    },
                    { field: formatMessage({ id: 'common.email', defaultMessage: 'Email' }) }
                )
            )
            .matches(
                EMAIL_REGEX,
                formatMessage(
                    {
                        id: 'schema.errors.invalid',
                        defaultMessage: '{field} is invalid',
                        description:
                            'Error message displayed when user enters a value that does not match the required format. Used in forms',
                    },
                    { field: formatMessage({ id: 'common.email', defaultMessage: 'Email' }) }
                )
            ),
    });
